// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { ReportIoAreaId, ReportIoAreaRoutes } from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'

import {
  ReportIoAreaNavigation,
  ReportIoAreaNavigationIcon,
} from './ReportIoAreaNavigation'

const LazyReportIoComponent = lazy(() => import('./ReportIoArea'))

const ReportIoComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyReportIoComponent />
  </SuspenseLoadingWrapper>
)

export const ReportIoArea = {
  id: ReportIoAreaId,
  Icon: ReportIoAreaNavigationIcon,
  NavigationComponent: ReportIoAreaNavigation,
  route: {
    path: ReportIoAreaRoutes.route,
    component: ReportIoComponent,
  },
}
